import DebtTableForOffice from './DebtTableForOffice';
export default DebtTableForOffice;
